<template>
  <div class="m-0 p-0">
    <LoadingSpinner v-if="loading" />

    <div v-else class="col-md-12 w-100 my-3 card p-0"> 
        <div class="text-center my-2">
          <Pagination
            :total="total"
            :totalpage="targets.length"
            :model="model"
            :limit="false"
            :color="'primary'"
            @changePage="getData(selected.user.id)"
            key="paginationkey"
          >
          </Pagination>
        </div>

        <div class="mx-0 px-0 table-responsive">
          <Table
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="targets"
            :checkbox="false"
            :key="100"
            @openTarget="openTarget"
            @goToClient="goToClient"
          >
          </Table>
        </div>
      </div>
    
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { usersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";

export default {
  name: 'OrdersBooker',
  components: {
    LoadingSpinner,
    Table,
    Pagination,
  },
  props: {
    selected:{
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: {
        cantPerPage: 50,
        currentPage: 1,
      },
      total: 0,
      targets: null,
      loading: true,
      exampleData: '',
      cols: [
        [
          {
            value: "status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-circle text-success",
              },
              {
                icon_if_value: "0",
                icon_true: "icon-circle text-secondary",
              },
            ],
          },
        ],  
        [
          {
            value: "language_id",          
            type: "image",
            hasTooltip: "language_name",
            isStatic: true,
          },
        ],
        [
          {
            value_label: "name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "openTarget",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToClient",
          },
        ],
        [
          {
            value: "verified_tasks",
            class: "text-primary",
          },
        ],  
        [
          {
            value: "meetings_booked",
            class: "text-primary",
          },
        ],  
        [
          {
            value: "meeting_rate",
            class: "text-primary",
            format: "percentage",
          },
        ],  
      
      ],
      headers: [
        {
          label: "Status",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
          {
          label: "Language",
          class: "overflowhide",
          id: 8,
        },
        {
          label: this.$t("lang.token.order_name"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Client",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 5,
        },
        {
          label: "Verified tasks",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 3,
        },
        {
          label: "Meetings booked",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 4,
        },
        {
          label: "Meetings rate",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 5,
        },

      ],
    };
  },  
  methods: {
    openTarget(target_id) {
      let url = "/orders/" + target_id;
      window.open(url, "_blank");
    },
    goToClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    getData(user_id) {
      this.loading = true;
        usersService.getOrdersBooker(user_id, this.model)
        .then( res => {
          if (res !== undefined) {
            this.targets = res.result.data;
            console.log(res.result);
            this.total = parseInt(res.result.total);

            this.loading = false;
          }
        })
        .catch((err) => console.log(err));
    }
  },
  created() {
    this.getData(this.selected.user.id)
  }  
};
</script>

<style scoped>
</style>
